import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import CustomerService from '@/services/CustomerService'

export default function CustomerCard2({ customerId, handleChange, onLoaded }) {
	// Simple display values without complex logic
	const { t } = useTranslation()

	const [customerDetails, setCustomerDetails] = React.useState({
		name: '',
		email: '',
		tel: '',
		address: '',
	})
	const [loading, setLoading] = React.useState(false)
	const [loadError, setLoadError] = React.useState(false)

	const loadCustomer = useCallback(async(id) => {
		if(!id) return
		setLoading(true)
		setLoadError(false)
		// console.log(`Loading customer details for ID: ${id}`)
		let {data, error } = await CustomerService.getCustomerById(id)
		// console.log(`TCL -> CustomerCard.jsx:18 -> loadCustomer -> data, error :`, data, error )
		if(error) {
			setLoadError(true)
			setCustomerDetails({
				email: '',
				tel: '',
				address: '',
				name: '',
			})
			setLoading(false)
			return
		} else if(data) {
			setCustomerDetails({
				name: data.name || '',
				email: data.email || '',
				tel: data.tel || '',
				address: data.address || '',
			})
			if (onLoaded) {
				onLoaded(data)
			}
		}
		setLoading(false)
	}, [onLoaded])

	useEffect(() => {
		if (!customerId) return
		loadCustomer(customerId)
	}, [customerId, loadCustomer])

	const getDisplayValue = value => {
		if (loading) return t('customerCard.loading')
		if (loadError) return t('customerCard.errorLoading')
		return value || t('customerCard.na')
	}

	return (
		<div className={`rounded-none sm:rounded-lg border border-gray-200 p-4`}>
			<div className="w-full">
				<div className="flex justify-between items-center mb-2">
					<div className="text-sm text-gray-600">{t('customerCard.title')}</div>
					<button
						type="button"
						onClick={handleChange}
						className="px-3 py-1 text-xs font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded border border-blue-200 hover:border-blue-300 transition-colors"
					>
						{t('customerCard.changeCustomer')}
					</button>
				</div>

				<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 text-sm">
					<div>
						<div className="text-gray-600">{t('customerCard.labels.name')}</div>
						<div className="font-medium text-gray-900">{getDisplayValue(customerDetails.name)}</div>
					</div>

					<div className="min-w-0">
						<div className="text-gray-600">{t('customerCard.labels.email')}</div>
						<div className="font-medium text-gray-900 break-words">{getDisplayValue(customerDetails.email)}</div>
					</div>

					<div>
						<div className="text-gray-600">{t('customerCard.labels.phone')}</div>
						<div className="font-medium text-gray-900">{getDisplayValue(customerDetails.tel)}</div>
					</div>

					<div>
						<div className="text-gray-600">{t('customerCard.labels.address')}</div>
						<div className="font-medium text-gray-900 whitespace-pre-wrap">{getDisplayValue(customerDetails.address)}</div>
					</div>
				</div>
			</div>
		</div>
	)
}
